import { useRef, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import { actualizarFotoUsuario } from "../../services/users.service";
import { getTema, setTema } from "../../functions/theme";
import Avatar from "../funcionales/Avatar";
import "./css/PerfilUsuario.css";

const PerfilUsuario = () => {
  const { user, fullUser, refrescarUsuario } = useAuth();
  const inputRef = useRef();
  const [subiendo, setSubiendo] = useState(false);
  const [error, setError] = useState("");
  const [oscuro, setOscuro] = useState(getTema() === "dark");

  const handleArchivo = async (e) => {
    const archivo = e.target.files?.[0];
    e.target.value = ""; // permite volver a elegir el mismo archivo despues
    if (!archivo) return;

    if (!archivo.type.startsWith("image/")) {
      setError("Elegí un archivo de imagen.");
      return;
    }

    setError("");
    setSubiendo(true);
    try {
      await actualizarFotoUsuario({
        userRowId: fullUser.id,
        authUid: user.id,
        archivo,
      });
      await refrescarUsuario();
    } catch (err) {
      setError(err.message || "No se pudo subir la foto.");
    } finally {
      setSubiendo(false);
    }
  };

  const handleToggleTema = () => {
    const nuevo = oscuro ? "light" : "dark";
    setTema(nuevo);
    setOscuro(!oscuro);
  };

  return (
    <div className="perfil-usuario">
      <div className="perfil-usuario__avatar-row">
        <button
          type="button"
          className="perfil-usuario__avatar-btn"
          onClick={() => inputRef.current?.click()}
          disabled={subiendo}
          title="Cambiar foto de perfil"
        >
          <Avatar
            nombreCompleto={fullUser?.nombreCompleto}
            fotoUrl={fullUser?.foto_url}
            size={64}
          />
          <span className="perfil-usuario__avatar-overlay">
            {subiendo ? "..." : "Cambiar"}
          </span>
        </button>
        <input
          ref={inputRef}
          type="file"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleArchivo}
        />
        <span className="field-helper">
          Se ajusta sola a 512×512 px como máximo al subirla.
        </span>
      </div>
      {error && <p className="combustible-error">{error}</p>}

      <div className="perfil-usuario__tema-row">
        <span>Modo oscuro</span>
        <button
          type="button"
          role="switch"
          aria-checked={oscuro}
          className={`perfil-usuario__switch ${oscuro ? "is-on" : ""}`}
          onClick={handleToggleTema}
        >
          <span className="perfil-usuario__switch-knob" />
        </button>
      </div>
    </div>
  );
};

export default PerfilUsuario;
